import { RotateCcw } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { OrderSelect } from "./OrderControls";

export const ModelSelector = ({ models, value, onChange, disabled = false, prefix = "order" }) => {
  const { t } = useLanguage();
  if (models.error) return <div role="alert" data-testid={`${prefix}-models-error`} className="text-sm text-rose-300">
    <p>{t(models.error)}</p>
    <button type="button" data-testid={`${prefix}-models-retry`} onClick={models.retry} className="btn-ghost mt-3"><RotateCcw size={14} />{t("Retry")}</button>
  </div>;
  return <OrderSelect id={`${prefix}-ai-model`} testId={`${prefix}-ai-model-select`} label="ChatGPT model"
    value={value} onChange={onChange} disabled={disabled || !models.catalog}
    placeholder={!models.catalog ? "Loading models…" : undefined}
    options={(models.catalog?.models || []).map(model => ({ value: model.id, label: model.name }))} />;
};